// Patch: ensure the hidden variant ID updates in *all* cart forms when options change.
document.addEventListener('DOMContentLoaded', () => {
  ['variant-radios', 'variant-selects'].forEach((tag) => {
    const Klass = customElements.get(tag);
    if (!Klass) return;

    const original = Klass.prototype.updateMasterId;
    Klass.prototype.updateMasterId = function () {
      // keep Dawn's native behavior
      if (original) original.call(this);

      const sectionId = this.dataset.section;
      const root =
        (sectionId && document.querySelector(`[data-section="${sectionId}"]`)) ||
        this.closest('[data-section]') ||
        document;

      const v = this.currentVariant;

      // update EVERY add-to-cart form's hidden id on this section
      root.querySelectorAll('form[action*="/cart/add"] input[name="id"], product-form input[name="id"]').forEach((input) => {
        if (v && v.id) {
          input.value = v.id;
          input.disabled = false;
        } else {
          input.value = '';
          input.disabled = true;
        }
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    };
  });
});
